import { render, staticRenderFns } from "./AppendageSelectGoods.vue?vue&type=template&id=41a5f9b6&scoped=true"
import script from "./AppendageSelectGoods.vue?vue&type=script&lang=js"
export * from "./AppendageSelectGoods.vue?vue&type=script&lang=js"
import style0 from "./AppendageSelectGoods.vue?vue&type=style&index=0&id=41a5f9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a5f9b6",
  null
  
)

export default component.exports